namespace $ { $mol_style_attach( "bog/ainews/app/page/page.view.css",
 "[bog_ainews_app_page] {\n\tflex: 1 0 40rem;\n}\n"
) }